const InvestmentFundView = require('./InvestmentFundView');

module.exports = InvestmentFundView;
